export default "__VITE_ASSET__viy39oXf__"